import React from 'react';

const Icon = ({ icon, className = '' }) => (
  <span className={`icon ${className}`}>
    <i className={icon} />
  </span>
);

export default Icon;
